import {Injectable} from '@angular/core';
@Injectable()
export class ApiService {

    show_header_footer = true;
    admin_layout = false;

    loadAppContent ( ) {
        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined';
        if (!isBrowser) {
            return false;
        }
        return window.location.href.endsWith('#/');
    }

}
